import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ethers } from 'ethers'
import { CHALLENGE_ABI } from '../abis/ChallengeABI'

function parseRefundError(err: unknown): string {
  if (err instanceof Error) {
    const msg = err.message
    if (msg.includes('user rejected') || msg.includes('ACTION_REJECTED'))
      return '트랜잭션을 거부했습니다'
    if (msg.includes('already refunded')) return '이미 환불받았습니다'
    if (msg.includes('not failed')) return '환불 가능한 상태가 아닙니다'
    if (msg.includes('not a participant')) return '참가자가 아닙니다'
    return msg.slice(0, 100)
  }
  return '환불에 실패했습니다'
}

/** Reclaim the entry fee from a failed (under-min) challenge — pull pattern. */
export function useRefund(challengeAddress: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      if (!window.ethereum) throw new Error('MetaMask가 설치되어 있지 않습니다')
      const browserProvider = new ethers.BrowserProvider(window.ethereum)
      const signer = await browserProvider.getSigner()
      const contract = new ethers.Contract(challengeAddress, CHALLENGE_ABI, signer)
      const tx = await (contract.refund as () => Promise<ethers.TransactionResponse>)()
      await tx.wait()
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['challenge-detail', challengeAddress] })
      void queryClient.invalidateQueries({ queryKey: ['my-page'] })
    },
    meta: { parseError: parseRefundError },
  })
}

export { parseRefundError }
